import { render, staticRenderFns } from "./LandingWishlistFR-V2.vue?vue&type=template&id=9ed486ce&scoped=true"
import script from "./LandingWishlistFR-V2.vue?vue&type=script&lang=js"
export * from "./LandingWishlistFR-V2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed486ce",
  null
  
)

export default component.exports